import i18n from '../i18n'

const SUPPORTED = ['pl', 'en']

const OVERRIDE_KEY = 'languageOverride'

export type AppLanguage = 'pl' | 'en'

export const LANGUAGES: AppLanguage[] = ['pl', 'en']

export const currentLanguage = (language?: string): AppLanguage =>
  language?.startsWith('pl') ? 'pl' : 'en'

export const setLanguage = (language: AppLanguage) => {
  localStorage.setItem(OVERRIDE_KEY, language)
  if (i18n.resolvedLanguage === language) return
  return i18n.changeLanguage(language)
}

export const applyProfileLanguage = (language?: string) => {
  if (localStorage.getItem(OVERRIDE_KEY)) return
  if (!language || !SUPPORTED.includes(language)) return
  if (i18n.resolvedLanguage === language) return
  return i18n.changeLanguage(language)
}
